import { useRouter } from "next/router"
import { useEffect } from "react"

export default function useOnRouterChange (callback) {
  const router = useRouter()

  useEffect(() => {
    router.events.on('routeChangeComplete', callback)

    return () => {
      router.events.off('routeChangeComplete', callback)
    }
  }, [])
}